import React from 'react'
import AppFormFooterBar from '../../../components/AppFormFooterBar'
import {
  AcademicCurriculumSection,
  ScheduleTimingSection,
  OrganizationScopeSection,
} from '../../../components/education-form'
import SyllabusTipsCard from './components/SyllabusTipsCard'
import useSyllabusEntryScreen from './hooks/useSyllabusEntryScreen'

export default function SyllabusEntryScreen() {
  const { state, actions } = useSyllabusEntryScreen()

  if (state.loading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <span className="material-symbols-outlined animate-spin text-3xl text-primary">progress_activity</span>
          <p className="text-xs font-semibold text-on-surface-variant">Loading syllabus details...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Top Header ── */}
      <section className="flex flex-col gap-1">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
          {state.isEditMode ? 'Edit Syllabus Curriculum' : 'Add New Syllabus'}
        </h1>
        <p className="text-xs text-on-surface-variant">
          Configure chapter details, teaching hour estimates, and syllabus milestones.
        </p>
      </section>

      {/* ── 2-Column Responsive Layout ── */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* Left Column: Form Fields (8 cols) */}
        <div className="lg:col-span-8 flex flex-col gap-6">

          {/* ── Card 1: Academic & Curriculum ── */}
          <AcademicCurriculumSection
            academicYear={state.academicYear}
            onAcademicYearChange={actions.setAcademicYear}
            academicYearOptions={state.options.academicYears}
            course={state.course}
            onCourseChange={actions.setCourse}
            courseOptions={state.options.courses}
            subject={state.subject}
            onSubjectChange={actions.setSubject}
            subjectOptions={state.options.subjects}
            showChapterNo={true}
            chapterNo={state.chapterNo}
            onChapterNoChange={actions.setChapterNo}
            showTopic={true}
            topic={state.chapterName}
            onTopicChange={actions.setChapterName}
            topicLabel="Chapter / Topic"
            topicPlaceholder="e.g. Depreciation Accounting & Provisions"
            showHours={true}
            hours={state.hours}
            onHoursChange={actions.setHours}
            showVideoUrl={true}
            videoUrl={state.videoUrl}
            onVideoUrlChange={actions.setVideoUrl}
          />

          {/* ── Card 2: Schedule & Timing ── */}
          <ScheduleTimingSection
            showDate={true}
            date={state.startDate}
            onDateChange={actions.setStartDate}
            dateLabel="Date From"
            showTillDate={true}
            tillDate={state.endDate}
            onTillDateChange={actions.setEndDate}
            tillDateLabel="Till Date"
            showTime={false}
          />

          {/* ── Card 3: Organization & Target Scope ── */}
          <OrganizationScopeSection
            showCompany={false}
            showBranch={false}
            showBatch={false}
            showSchool={true}
            school={state.allSchools ? 'All' : state.schoolCollege}
            onSchoolChange={actions.setSchoolCollege}
            schoolOptions={state.options.schools}
            showSchoolScope={true}
            schoolScope={state.allSchools ? 'All' : 'Single'}
            onSchoolScopeChange={(scope) => actions.handleAllSchoolsToggle(scope === 'All')}
          />

        </div>

        {/* Right Column: Tips Card (4 cols) */}
        <div className="lg:col-span-4 sticky top-6">
          <SyllabusTipsCard />
        </div>
      </div>

      {/* ── Global Sticky Form Footer Bar ── */}
      <AppFormFooterBar
        cancelPath="/lectures/syllabus"
        isSaving={state.saving}
        showSaveAndContinue={!state.isEditMode}
        onSaveContinue={() => actions.handleSave(true)}
        onSaveExit={() => actions.handleSave(false)}
        saveLabel={state.isEditMode ? 'Update & Exit' : 'Save & Exit'}
      />
    </div>
  )
}
